const AvailableModes = [
  {
    value: 0,
    label: 'Hours',
    isSelected: false
  },
  {
    value: 1,
    label: 'Days : Hours : Minutes',
    isSelected: true
  }
];

export default AvailableModes;
